import {useTooltipContext} from '../hooks/useTooltipContext'
import {CalendarItemData} from './CalendarDateItem'

export const useCalendarItemData = () => {
  return useTooltipContext<CalendarItemData>()
}
